import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter, Switch, Route, Redirect } from "react-router-dom";

import home from "./home";
import about from "./about";
import gifshop from "./gifshop";
import swipe from "./swipe";
import setlist from "./setlist";
import brite from "./brite";
import preventDefault from "./prevent_default";
import offBalance from "./off-balance";
import americaOffBalance from "./america-off-balance";
import product from "./product";
import whereby from "./whereby";
import recollect from "./recollect";
import flexhouse from "./flexhouse";
import visualElectric from "./visual-electric";

import "./css/reset.css";
import "./css/index.css";

const Main = () => (
  <Switch>
    <Route exact path="/" component={home} />
    <Route exact path="/about" component={about} />
    <Route exact path="/swipe" component={swipe} />
    <Route exact path="/swipe-product-overview" component={product} />
    <Route exact path="/gifshop" component={gifshop} />
    <Route exact path="/setlist" component={setlist} />
    <Route exact path="/brite" component={brite} />
    <Route exact path="/preventdefault" component={preventDefault} />
    <Route exact path="/off-balance" component={offBalance} />
    <Route exact path="/america-off-balance" component={americaOffBalance} />
    <Route exact path="/whereby" component={whereby} />
    <Route exact path="/re-collect" component={recollect} />
    <Route exact path="/flexhouse" component={flexhouse} />
    <Route exact path="/visual-electric" component={visualElectric} />
    <Redirect to="/" />
  </Switch>
);

ReactDOM.render(
  <BrowserRouter>
    <Main />
  </BrowserRouter>,
  document.getElementById("root"),
);



// WEBPACK FOOTER //
// ./src/index.js